import { navModule } from './modules/nav';
import { searchModule } from './modules/search';
import { homeModule } from './modules/home';
import homePlugin from '@backstage/plugin-home/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import { apiDocsPluginFrontendOverride } from './modules/apis';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { orgPlugin } from '@backstage/plugin-org';
import { techdocsPlugin } from '@backstage/plugin-techdocs';
import { createApp } from '@backstage/frontend-defaults';
import { convertLegacyRouteRef, convertLegacyRouteRefs } from '@backstage/core-compat-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { cfaApiSdkModule, cfaApiSdkPlugin } from './modules/cfa-api-sdk';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { catalogPluginOverride } from './modules/catalog';
import { techDocsPluginOverride } from './modules/documentation';
import { techDocsMermaidAddonModule } from 'backstage-plugin-techdocs-addon-mermaid';
import { scmIntegrationsApi } from './modules/scm-integrations';
import { signInPage } from './modules/sign-in';
import { devToolsPageExtension } from './modules/devtools';
import { staticLandscapePageExtension } from './modules/landscape';
import { scaffolderPluginOverride } from './modules/scaffolder';
import { entityValidationConverted } from './modules/entity-validation';
import { awsAccountsModule } from './modules/aws-accounts';
import { kubeSelfServePageModule } from './modules/kube-self-serve';
import adrPlugin from '@backstage-community/plugin-adr/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import { userSettingsPluginOverride } from './modules/settings';
import searchPlugin from '@backstage/plugin-search/alpha';
import { cfaLightThemeExtension, cfaDarkThemeExtension } from './theme/themeOverrides';
import { cfaAppThemeModule } from './modules/app';
import { healthIndicatorModule } from './modules/health-indicator';
import { homesteadFeatureFlagsModule } from './modules/feature-flags';
import { debouncedAlertsModule } from './modules/debounced-alerts';
import { dttTeamviewPageModule } from './modules/dtt-teamview';
import { datadogRumModule } from './modules/datadog-rum';
import { buildInfoModule } from './modules/build-info';
import { sparkPlugin } from './modules/spark';

const appModules = createFrontendModule({
  pluginId: 'app',
  extensions: [
    cfaLightThemeExtension,
    cfaDarkThemeExtension,
    scmIntegrationsApi,
    signInPage,
    devToolsPageExtension,
    staticLandscapePageExtension,
  ],
});

const app = createApp({
  features: [
    appModules,
    cfaAppThemeModule,
    buildInfoModule,
    datadogRumModule,
    homesteadFeatureFlagsModule,
    debouncedAlertsModule,
    healthIndicatorModule,
    navModule,
    adrPlugin,
    catalogPluginOverride,
    catalogGraphPlugin,
    apiDocsPluginFrontendOverride,
    techDocsPluginOverride,
    techDocsMermaidAddonModule,
    userSettingsPlugin,
    userSettingsPluginOverride,
    homePlugin,
    homeModule,
    searchPlugin,
    searchModule,
    scaffolderPluginOverride,
    entityValidationConverted,
    cfaApiSdkPlugin,
    cfaApiSdkModule,
    awsAccountsModule,
    kubeSelfServePageModule,
    dttTeamviewPageModule,
    sparkPlugin,
  ],
  bindRoutes({ bind }) {
    bind(convertLegacyRouteRefs(catalogPlugin.externalRoutes), {
      createComponent: convertLegacyRouteRef(scaffolderPlugin.routes.root),
      viewTechDoc: convertLegacyRouteRef(techdocsPlugin.routes.docRoot),
      createFromTemplate: convertLegacyRouteRef(scaffolderPlugin.routes.selectedTemplate),
    });
    bind(convertLegacyRouteRefs(apiDocsPlugin.externalRoutes), {
      registerApi: false,
    });
    bind(convertLegacyRouteRefs(scaffolderPlugin.externalRoutes), {
      registerComponent: false,
      viewTechDoc: convertLegacyRouteRef(techdocsPlugin.routes.docRoot),
    });
    bind(convertLegacyRouteRefs(orgPlugin.externalRoutes), {
      catalogIndex: convertLegacyRouteRef(catalogPlugin.routes.catalogIndex),
    });
  },
});

export default app.createRoot();